<!-- Update 1/04/22 -->
<div class="grid">
    <div class="col-12 grid">
      <div class="col-12">
        <h3 class="text-sm">
          {{ 'Total Revisiones' | translate }}:
          <em class="text-aqua">{{ today | date }}</em>
        </h3>
      </div>
      <div class="col-12 lg:col-4 md:col-6 sm:col-12">
        <kanzi-count-widget
          [type]="type1"
          [description]="description1"
          [path]="path"
          [filter]="filter1"
        ></kanzi-count-widget>
      </div>
      <div class="col-12 lg:col-4 md:col-6 sm:col-12">
        <kanzi-count-widget
          [type]="type2"
          [description]="description2"
          [path]="path"
          [filter]="filter2"
        ></kanzi-count-widget>
      </div>
      <div class="col-12 lg:col-4 md:col-6 sm:col-12">
        <kanzi-count-widget
          [type]="type3"
          [description]="description3"
          [path]="path"
          [filter]="filter3"
        ></kanzi-count-widget>
      </div>
    </div>
  </div>
  